import { GoogleMapConstants } from "../../constants";
import { googleMapService } from "../../services";

import { failure, custom } from "./utilities";

const { GET_LOCATION_DETAIL } = GoogleMapConstants;

export const getLocationDetail = (lat, lng) => {
  return async (dispatch) => {
    try {
      const response = await googleMapService.getLocationDetail(lat, lng);
      if (response) {
        const responseLength = response.data.results.length;
        const addressComponents = response.data.results[0].address_components;

        const city = addressComponents.find((component) =>
          component.types.includes("locality")
        );

        const countryCode =
          response.data.results[responseLength - 1].address_components[0]
            .short_name;

        dispatch(
          custom({ countryCode, city: city.long_name }, GET_LOCATION_DETAIL)
        );
      }
    } catch (error) {
      dispatch(failure(error.message, GET_LOCATION_DETAIL));
    }
  };
};

export const googleMapActions = {
  getLocationDetail,

};
